import React from "react";
import { useContext } from "react";
import { ThemeContext } from "../../../../../context/theme/ThemeContext";
import Style from "../AnnounceLayout/announcelayout.module.scss";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { Close, Filter, Search, Sort } from "@mui/icons-material";
import moment from "moment";
import AnnouncementData from "../../../../../data/announcement.json";
import { ModalLayout, TextEditor } from "../../../../../components";

import {
  authGetRequest,
  authPostRequest,
} from "../../../../../api/laravel/public/api";
import {
  errorMessage,
  successMessage,
} from "../../../../../utils/notification";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";

function Submission(props) {
  const { theme, changeTheme } = useContext(ThemeContext);
  const [input, setInput] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [file, setFile] = React.useState(null);
  const [data, setData] = React.useState({});
  const [modal, setModal] = React.useState(false);
  const { type, view, assignment } = props;

  const handleInput = (label, e) => {
    setInput({ ...input, [label]: e });
  };

  const handleFileChange = (e) => {
    if (!e.target.files) {
      return;
    }

    setFile(e.target.files[0]);
  };

  React.useEffect(() => {
    setData(assignment);
  }, [assignment]);

  const submitAssesment = async (e) => {
    e.preventDefault();
    let id = view?.id;
    var formdata = new FormData();
    formdata.append("file", file);
    formdata.append("description", input["description"]);
    setLoading(true);
    const { data_r, isError, isLoading } = await authPostRequest(
      "/account/course/submit/" + id,
      formdata
    );
    setData(data_r);
    setLoading(false);
  };

  return (
    <div className={Style.announce_layout}>
      <hr />
      <div className="announce_container p-2">
        {view?.type != "assignment" && view?.type != "project" && (
          <div className="d-flex flex-column align-items-center justify-content-center my-4">
            <h4 className="sm black">No assignment in this section</h4>
          </div>
        )}
        {view?.type === "assignment" || view?.type === "project" && (
          <div className="row my-4 mx-1">
            <div className="col-md-12">
              <div className="d-flex flex-row align-items-center my-3">
                <small>Your Grade:</small>
                {!data?.mark_by && (
                  <b className="mx-2">Not yet</b>
                )}
                {data?.mark_by && (
                  <b className="mx-2">{data?.score}</b>
                )}
              </div>
              <div className="d-flex flex-row align-items-center my-3">
                <small>Status:</small>
                {!data?.course_section_item_id && (
                  <span className="btn btn-warning btn-sm mx-2">
                    Waiting for Submission
                  </span>
                )}
                {data?.course_section_item_id &&
                  data?.course_section_item_id != view.id && (
                    <span className="btn btn-warning btn-sm mx-2">
                      Waiting for Submission
                    </span>
                  )}
                {data?.course_section_item_id &&
                  data?.course_section_item_id == view.id && (
                    <span className="btn btn-success btn-sm mx-2">
                      Submission received
                    </span>
                  )}
              </div>
              {/* <table className=" mb-3">
                <tbody>
                  <tr style={{ margin: 20 }}>
                    <td>Your Grade:</td>
                    {!data?.course_section_item_id && (
                      <td style={{ color: "black" }}> Not yet</td>
                    )}
                    {data?.mark_by && (
                      <td style={{ color: "black" }}>{data?.score}</td>
                    )}
                  </tr>
                  <tr>
                    <td>Status:</td>
                    {!data?.course_section_item_id && (
                      <td>
                        <span className="btn btn-warning btn-sm">
                          Waiting for Submission
                        </span>
                      </td>
                    )}
                    {data?.course_section_item_id &&
                      data?.course_section_item_id != view.id && (
                        <td>
                          <span className="btn btn-warning btn-sm">
                            Waiting for Submission
                          </span>
                        </td>
                      )}
                    {data?.course_section_item_id &&
                      data?.course_section_item_id == view.id && (
                        <td>
                          <span className="btn btn-success btn-sm">
                            Submission received
                          </span>
                        </td>
                      )}
                  </tr>
                </tbody>
              </table> */}
              {!data?.course_section_item_id && (
                <form id="grade_assignment">
                  <div className="mb-3">
                    <label className="form-label">
                      Upload Document (Docx or PDF file only, 2MB Max)
                    </label>
                    <input
                      type="file"
                      onChange={handleFileChange}
                      className="form-control"
                      name="score"
                      accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
                      id="basic-default-fullname"
                      placeholder="Upload a file"
                    />
                  </div>
                  <div className=" mb-4">
                    <label
                      className="form-label"
                      htmlFor="basic-default-company"
                    >
                      Explanation
                    </label>
                    <div className="post-editor text-form-editor">
                      <img src={"images/editor-demo-1.jpg"} alt="" />
                      <textarea placeholder="Description" value={input['description']} onChange={(e) => handleInput("description", e.target.value)} defaultValue={""} />
                    </div>
                   
                  </div>

                  <div className="my-4 mb-3">
                    <button
                      disabled={loading}
                      id="button_grade"
                      onClick={submitAssesment}
                      type="submit"
                      className="mc-btn btn-style-1"
                    >
                      {!loading && `Submit`}
                      {loading && (
                        <div className="d-flex flex-row">
                          <CircularProgress
                            size={15}
                            sx={{ color: "white", marginRight: 2 }}
                          />
                          <p>Connecting</p>
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Submission;
